import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { ApiService } from "../../../services/api.service";
import { colorCodes } from "../../../constants/app-colors.constants";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { AsyncWidget, SyncWidget } from "mis-crystal-design-system/widgets";
import { ConfigurationService } from "../../../services/configuration.service";
import { AnalyticsService } from "mis-crystal-design-system/analytics";
import { concatMap } from "rxjs/operators";
@Component({
  selector: "mis-employee-web-exp-calender-card",
  templateUrl: "./calender-card.component.html",
  styleUrls: ["./calender-card.component.scss"]
})
export class CalenderCardComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  @Output() showTeamCalender = new EventEmitter<MouseEvent>();
  teamMates: NsEmpWebExpData.ITeammateData;
  employeeName = [
    {
      empguid: "",
      name: "",
      projectGuid: "",
      projectName: ""
    }
  ];
  message = "";
  suffixString = "coming to office today.";
  initialsName = [];

  @Input() widgetControl: SyncWidget;
  @Input() bookingStream: AsyncWidget;
  resizeCard: boolean = false;
  resizedHeight = "";

  constructor(private apiSvc: ApiService, private configSvc: ConfigurationService, private analytics: AnalyticsService) {}

  ngOnInit(): void {
    let extra;
    this.widgetControl?.toggleLoader(true);
    this.bookingStream.value
      .pipe(
        concatMap(booking => {
          return this.configSvc.applyOfficeConfigurations(booking);
        })
      )
      .subscribe(response => {
        if (response?.booking?.list) {
          this.resizeCard = Object.entries(response?.booking?.list)?.length > 0;
          this.resizedHeight = "240px";
        }
        this.widgetControl?.toggleLoader(false);
      });

    this.apiSvc.getTeamMates().subscribe(
      res => {
        this.teamMates = res;
        if (this.teamMates?.employees?.length > 0) {
          extra = this.teamMates?.employees?.length - 3;
          this.employeeName = this.teamMates.employees.slice(0, 3);
          this.employeeName.forEach(element => {
            let names = element?.name?.split(" "),
              initials = names?.[0]?.substring(0, 1)?.toUpperCase();
            if (names?.length > 1) {
              initials += names?.[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            }
            let obj = {
              name: initials,
              color: colorCodes.sort(() => 0.5 - Math.random()).slice(0, 1)
            };
            this.initialsName.push(obj);
          });
          let arrayOfNames = this.capitalizeName(this.employeeName).map(element => {
            if (element?.length > 0) return element.join(" ");
            else return element;
          });
          if (this.teamMates?.employees?.length > 0) {
            this.message = this.teamMates.displayMessage;
          }
        } else this.message = "None of your teammates are working from office today.";
      },
      err => {
        this.widgetControl?.toggleLoader(false);
      }
    );
  }
  teamCalender(event: MouseEvent) {
    this.analytics.send("emp_web_team_calendar", "emp_web", "click", "");
    if (this.configSvc.isTeamsApp) {
      window.parent.postMessage(
        {
          app: "EMPLOYEE_EXPERIENCE_UI",
          eventType: "EMPLOYEE_TEAM_CALENDAR_OPEN",
          value: {
            openTeamCalendar: true
          }
        },
        "*"
      );
      return;
    }
    this.showTeamCalender.emit(event);
  }
  capitalizeName(names) {
    return names.map(function (name) {
      return name?.name?.split(" ").map(function (word) {
        return word?.[0]?.toUpperCase() + word.slice(1)?.toLowerCase();
      });
    });
  }
}
